/* eslint-disable react/prop-types */
import React, { Fragment, useEffect, useMemo, useState } from 'react';

import _, { get } from 'lodash';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Button, Divider } from '@telus-uds/components-web';
import { Error } from '../design/elements';
import FormField from './formField';
import {
  SeatDetailsButtonWrapper,
  BoxWrapper,
  GroupTitle,
  GroupWrapper
} from './css';
import SeatDetailsTable from './seatDetailsTable';
import request from '../utils/request';
import submitPayload from './formSubmitLogic';
import {
  contentFulFields,
  fieldBusinessConnectEdition,
  fieldCoperToFibreMigration,
  fieldNoteOfficeSeat,
  fieldNoteStarterSeat,
  fieldWillTheTollFreeBePortedIn,
  fieldWillTheLocalPhoneNumberBePortedIn,
  fieldProvider,
  orderDetailsForm,
  fieldC2fAutomatedActivation,
  fieldOfficeSeatFirstName,
  fieldOfficeSeatLastName,
  fieldOfficeSeatEmail,
  fieldRecontractCustomer,
  fieldRecontractSeatsCustomerAdding,
  fieldDeviceType,
  filedIsTheirAnyReasonToGoThroughMySOF,
  fieldCustomerTollFreeLocalNumberOdyssey,
  fieldRateCenterProvince,
  fieldRateCenter,
  fieldPhoneNumber,
  fieldTollFreePhoneNumber,
  fieldPhoneNumbersBeportedOdyssey,
  fieldOfficeSeats,
  fieldPhoneNumberOdyssey,
  invalidPhoneNumber,
  fieldWLSBusinessConnect,
  fieldIsThisAnEContractCustomer,
  filedNeedMoreThanSingleServiceAddress,
  filedNeedMediaAdvertisingBilling,
  filedNeedBilledDirectoryListing
} from '../utils/constant';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import stringInterpolation from '../utils/stringInterpolation';
import ValidateLoader from '../UI/validateLoader';
import { getPathVariables } from '../misc';
import { getFieldValue } from './utils/formCommon';
import { FieldInput } from './fields';

const SeatDetailsForm = ({
  data,
  orderData,
  updateStep,
  step,
  setOrderData,
  onSaveAndExit,
  isOrderFulfillmentTeam,
  prevStep
}) => {
  const history = useHistory();
  const {
    location: { pathname }
  } = history;
  const [locale, categoryName] = getPathVariables(pathname);
  const { starterSeatDetails, officeSeatDetails } = contentFulFields;
  const applyToX = 'applyToTheNextXSeatsOnThisOrder';
  const deviceType = 'deviceType';
  const localizedStrings = useLocalizedStringsContext();
  const {
    seatDetails: {
      errorMessage,
      errorTotalMessage,
      fieldRequiredMessage,
      npaLabel,
      nxxLabel
    },
    formButtons: {
      continueButtonLabel,
      nextSeatButtonLabel,
      saveContinueLaterButtonLabel,
      backButtonLabel
    },
    contentfulValues: {
      yes,
      no,
      deviceBYOD,
      editionMapping: { voice }
    },
    general: { loading },
    ODYSSEY_AI: {
    tollFree,
    odysseyPhoneNumber
  }
  } = localizedStrings;
  const { name, key, formFields } = data;
  const isRecontractFlow =
    _.get(orderData, fieldRecontractCustomer, '') === yes;
  const recontractCustomerAddingSeats = _.get(
    orderData,
    fieldRecontractSeatsCustomerAdding,
    0
  );

  const isOfficeSeat = key === officeSeatDetails;
  let seatCount;
  if (isRecontractFlow) seatCount = recontractCustomerAddingSeats;
  else
    seatCount = isOfficeSeat
      ? parseInt(orderData.officeSeats, 10)
      : parseInt(orderData.starterSeat, 10);
  const totalSeatCount = isRecontractFlow
    ? recontractCustomerAddingSeats
    : parseInt(orderData.officeSeats, 10) + parseInt(orderData.starterSeat, 10);
  const isc2fMigrationFlow =
    _.get(orderData, fieldCoperToFibreMigration, '') === yes;
  const isc2fAutomatedActivation =
    _.get(orderData, fieldC2fAutomatedActivation, '') === yes;

  const formObjectKeys = useMemo(() => {
    return formFields.reduce(
      (acc, { fields: { name: formName, value } }) => {
        acc[formName] = value;
        return acc;
      },
      {
        npa: 0,
        nxx: 0,
        number: 0,
        devicePaymentMethod: ''
      }
    );
  }, [formFields]);

  const [fieldErrors, setFieldErrors] = useState({});
  const [rateCenterData, setRateCenterData] = useState();
  const [isFormTouched, setIsFormTouched] = useState(false);
  const [forms, setForms] = useState([]);
  const [currentForm, setCurrentForm] = useState({
    ...formObjectKeys,
    creationDate: new Date()
  });
  const [currentIndex, setCurrentIndex] = useState(0);
  const valuePNportedIn = get(currentForm, fieldPhoneNumbersBeportedOdyssey);  
  const valueCustomerTollFree = get(currentForm, fieldCustomerTollFreeLocalNumberOdyssey);
  const valueIsTheirAnyReasonToGoThroughMySOF = 
  _.get(orderData, filedIsTheirAnyReasonToGoThroughMySOF, '') === yes;

const valueWLSBusinessConnect = _.get(orderData, fieldWLSBusinessConnect, '') === no;
const valueIsEContractCustomer = _.get(orderData, fieldIsThisAnEContractCustomer, '') === no;
const valueNeedMoreThanSingleServiceAddress = _.get(orderData, filedNeedMoreThanSingleServiceAddress, '') === no;
const valueNeedMediaAdvertisingBilling = _.get(orderData, filedNeedMediaAdvertisingBilling, '') === no;
const isThisOdysseyAIOrder = _.get(orderData, 'isThisOdysseyAI','') === yes;

  const isAllValuesNoOdyssey = valueWLSBusinessConnect && valueIsEContractCustomer && valueNeedMoreThanSingleServiceAddress && valueNeedMediaAdvertisingBilling;
  const searchString = paramStep => {
    return orderData && orderData.id
      ? `?orderId=${orderData.id}&step=${paramStep}`
      : '';
  };
  const redirect = newStep => {
    updateStep(newStep);
    history.push({
      pathname: `/${locale}/${categoryName}/${orderDetailsForm}`,
      search: searchString(newStep)
    });
  };

  const submitOrder = async updateFormsData => {
    const payload = { ...orderData, [key]: updateFormsData };
    if (isOfficeSeat) {
      let formsText = forms.reduce((acc, item) => {
        const text = acc ? `${acc}\n` : acc;
        return item[fieldNoteOfficeSeat]
          ? `${text}${item[fieldNoteOfficeSeat]}`
          : acc;
      }, '');
      formsText = formsText ? `${formsText}\n` : formsText;
      formsText = formsText
        ? `${formsText}${currentForm[fieldNoteOfficeSeat]}`
        : '';
      payload[fieldNoteOfficeSeat] = formsText;
    } else {
      payload[fieldNoteStarterSeat] = currentForm[fieldNoteStarterSeat];
    }
    const nextStep = (isAllValuesNoOdyssey || isThisOdysseyAIOrder) ? step + 2 : step + 1;
const response = await submitPayload(payload, nextStep );
    setOrderData(response.data);
    redirect(nextStep);
  };

  useEffect(() => {
    if (Object.keys(orderData).length !== 0) {
      if (seatCount === 0 || Number.isNaN(seatCount)) {
        submitOrder([]);
      }
    }
  }, [orderData]);

  useEffect(() => {
    request
      .get(`/rateCenter?country=CA&sortBy=RCLONG&sortOrder=ASC`)
      .then(response => {
        if (response && Array.isArray(response.data)) {
          setRateCenterData(response.data);
        }
      });
  }, [data]);

  const rateCenterObjectMap = useMemo(
    () =>
      rateCenterData &&
      rateCenterData.reduce((acc, rateCenter) => {
        const { npa, nxx, rclong, newDid, province } = rateCenter;
        if (acc[province]) {
          if (acc[province][rclong]) {
            if (acc[province][rclong][npa]) {
              if (acc[province][rclong][npa][nxx]) {
                acc[province][rclong][npa][nxx] = true;
              } else {
                acc[province][rclong][npa][nxx] = {};
              }
            } else {
              acc[province][rclong][npa] = {
                [nxx]: true
              };
            }
            if (acc[province][rclong].newDidCount) {
              if (newDid) acc[province][rclong].newDidCount += 1;
            } else {
              acc[province][rclong].newDidCount = newDid ? 1 : 0;
            }
          } else {
            acc[province][rclong] = {
              [npa]: {
                [nxx]: true
              },
              name: rclong,
              newDidCount: newDid ? 1 : 0
            };
          }
        } else {
          acc[province] = {
            [rclong]: {
              [npa]: {
                [nxx]: true
              },
              name: rclong
            }
          };
        }
        return acc;
      }, {}),
    [rateCenterData]
  );

  const portingNumbers = useMemo(
    () =>
      rateCenterData &&
      rateCenterData.reduce((acc, rateCenter) => {
        const { npa, nxx, province } = rateCenter;
        if (acc[province]) {
          if (acc[province][npa]) {
            acc[province][npa].push(nxx);
          } else {
            acc[province][npa] = [];
            acc[province][npa].push(nxx);
          }
        } else {
          acc[province] = {};
        }
        return acc;
      }, {}),
    [rateCenterData]
  );

  // const devicesMap = useMemo(() => {
  //   if (orderData && orderData.devices) {
  //     return orderData.devices.reduce(
  //       (acc, { name: deviceName, payForDevice }) => {
  //         acc[deviceName] = payForDevice;
  //         return acc;
  //       },
  //       {}
  //     );
  //   }
  //   return {};
  // }, [orderData]);

  const getDeviceQuantity = (deviceKey, includeCurrent = true) => {
    const [name, payForDevice] = deviceKey.split('__').map(x => x.trim());
  
    const getTotal = arrayData =>
      arrayData.reduce((acc, item) => {
        return item[deviceType] === name && item.devicePaymentMethod === payForDevice
          ? acc + 1
          : acc;
      }, 0);
    let result = 0;

    if (orderData[starterSeatDetails]) {
      result += getTotal(orderData[starterSeatDetails]);
    }
    if (forms.length) {
      result += getTotal(forms);
    } else if (!isFormTouched && orderData[officeSeatDetails]) {
      result += getTotal(orderData[officeSeatDetails]);
    }
    if (
      includeCurrent &&
      currentForm &&
      currentForm[deviceType] === name &&
      currentForm.devicePaymentMethod === payForDevice
    ) {
      result += 1;
    }

    return result;
  };

  const getByodInitQuantity = () => {
    const count =
      (orderData &&
        orderData.devices &&
        orderData.devices.reduce(
          (acc, device) => acc + (device.quantity || 0),
          0
        )) ||
      0;
    return totalSeatCount - count;
  };

  const getDeviceInitQuantity = deviceKey => {
    if (deviceKey === deviceBYOD) return getByodInitQuantity();
  
    const [name, payForDevice] = deviceKey.split('__').map(x => x.trim());
  
    if (!orderData || !orderData.devices) return 0;
  
    const count = orderData.devices.reduce((acc, item) => {
      const itemName = item.name.trim();
      const itemPayment = item.payForDevice.trim();
      return itemName === name && itemPayment === payForDevice ? acc + item.quantity : acc;
    }, 0);
    return count;
  };

  const devices = () => {
    let result = [];
    let totalDeviceCount = 0;
    if (orderData && orderData.devices) {
      const uniqueDeviceCombos = orderData.devices.reduce((acc, item) => {
        const key = `${item.name.trim()}__${item.payForDevice.trim()}`;
        return acc.includes(key) ? acc : [...acc, key];
      }, []);
      result = uniqueDeviceCombos.map(key => {
        const [name, paymentMethod] = key.split('__').map(x => x.trim());
        const count = getDeviceInitQuantity(key) - getDeviceQuantity(key);
        totalDeviceCount += getDeviceInitQuantity(key);
        return {
          fields: {
            value: key,
            label: `${name} (${paymentMethod}) (${count})`,
            disabled: count < 1
          }
        };
      });
    }
    if (totalDeviceCount !== totalSeatCount) {
      const byodCount =
        getDeviceInitQuantity(deviceBYOD) - getDeviceQuantity(deviceBYOD);
      result.push({
        fields: {
          value: deviceBYOD,
          label: `${deviceBYOD} (${byodCount})`,
          disabled: byodCount < 1
        }
      });
    }
    return result;
  };

  const formFieldMap = useMemo(
    () =>
      formFields.reduce((acc, { fields }) => {
        const { name: fieldName } = fields;
        const updatedFields = { ...fields };
        acc[fieldName] = { ...updatedFields };
        return acc;
      }, {}),
    [formFields]
  );

  const getRateCenterOptions = province => {
    return (
      province &&
      rateCenterObjectMap[province] &&
      Object.keys(rateCenterObjectMap[province]).map(
        rateCenter =>
          rateCenterObjectMap[province][rateCenter].newDidCount > 0 && {
            fields: {
              label: rateCenterObjectMap[province][rateCenter].name,
              value: rateCenter
            }
          }
      )
    );
  };

  const getNPAOptions = province => {
    if (province) {
      const npaMap = portingNumbers[province];
      return Object.keys(npaMap).sort();
    }
    return [];
  };

  const getNXXOptions = province => {
    if (province && currentForm.npa) {
      return portingNumbers[province][currentForm.npa].sort();
    }
    return [];
  };

  useEffect(() => {
    if (
      orderData &&
      orderData.id &&
      orderData[key] &&
      rateCenterData &&
      rateCenterData.length
    ) {
      const dbFormData = orderData[key];
      const seats = dbFormData.length;
      if (seats) {
        const newIndex = seats - 1;
        const currentFormData = dbFormData[newIndex];
        setCurrentForm({ ...currentFormData });
        setCurrentIndex(newIndex);
        dbFormData.splice(newIndex, 1);
        setForms(dbFormData);
      }
    }
  }, [rateCenterData]);

  const isRelatedFieldExisted = field => {
    const { name: fieldName, appearsAfterField, appearsAfterValue } = field;

    if (
      orderData[fieldBusinessConnectEdition] === voice &&
      [fieldWillTheTollFreeBePortedIn].includes(fieldName)
    ) {
      return false;
    }

    if (!appearsAfterField) return true;

    let isVisible = true;
    for (let i = 0; i < appearsAfterField.length; i += 1) {
      const {
        fields: { name: relatedFieldName }
      } = appearsAfterField[i];
      if (typeof currentForm !== 'undefined') {
        const relatedFieldValue = currentForm[relatedFieldName];
        isVisible =
          isVisible &&
          Array.isArray(appearsAfterValue) &&
          appearsAfterValue.find(
            item => relatedFieldValue === item.fields.value
          );
    }    
    }
    if (
      isc2fAutomatedActivation &&
      [
        fieldOfficeSeatFirstName,
        fieldOfficeSeatLastName,
        fieldOfficeSeatEmail
      ].includes(fieldName)
    )
      isVisible = true;

    return isVisible;
  };
  const handleFormField = (fieldName, value) => {
    setFieldErrors({});
    let updateValue = value;

    if (fieldName === applyToX && seatCount - forms.length <= +value) {
      setFieldErrors({
        applyToTheNextXSeatsOnThisOrder: stringInterpolation(
          errorMessage,
          seatCount
        )
      });
      updateValue = seatCount - forms.length - 1;
    }
    const updatedForm = { ...currentForm };
    if(fieldName === fieldPhoneNumbersBeportedOdyssey){
      const numberOfArray = Number(value);
      updatedForm.phoneNumberOdyssey = Array(numberOfArray).fill("");
    }
    //handle in renderform field
    // if (
    //   isc2fMigrationFlow &&
    //   fieldName === fieldWillTheLocalPhoneNumberBePortedIn &&
    //   value === yes
    // ) {
    //   updatedForm.provider = 'TELUS';
    //   updatedForm[fieldWillTheTollFreeBePortedIn] = 'No';
    // }
    if (fieldName === deviceType && value.includes('__')) {
      const [device, method] = value.split('__');
      updatedForm.deviceType = device;
      updatedForm.devicePaymentMethod = method;
    } else {
      updatedForm[fieldName] = updateValue;
      // BYOD (and any other non-composite device option) has no payment method -
      // clear a stale value left over from a previously-selected composite device,
      // otherwise the radio's computed `value` keeps the old "__" suffix and never
      // matches BYOD's own plain value, so it silently renders as unselected.
      if (fieldName === deviceType) {
        updatedForm.devicePaymentMethod = '';
      }
    }
    if (fieldName === 'rateCenterProvince') {
      updatedForm.rateCenter = '';
      updatedForm.npa = 0;
      updatedForm.nxx = 0;
      updatedForm.number = 0;
    }
    if (fieldName === 'rateCenter') {
      updatedForm.npa = 0;
      updatedForm.nxx = 0;
      updatedForm.number = 0;
    }
    updatedForm[fieldName] = updateValue;
    setCurrentForm(updatedForm);
    if (!isFormTouched) {
      setIsFormTouched(true);
    }

  };
  const onDelete = index => {
    forms.splice(index, 1);
    setCurrentIndex(forms.length);
    setForms([...forms]);
    if (!isFormTouched) {
      setIsFormTouched(true);
    }
  };
  const validateForm = () => {
    const result = {};
  
    Object.keys(formFieldMap).forEach(fieldKey => {
      const {
        ref,
      } = formFields && formFields[fieldKey] ? formFields[fieldKey] : {};  
      if (fieldKey === key) {
        result[fieldKey] = { ref };
      }  
      if (formFieldMap[fieldKey].required && !currentForm[fieldKey]) {
        result[fieldKey] = fieldRequiredMessage;
      }  
      if (!isRelatedFieldExisted(formFieldMap[fieldKey])) {
        delete result[fieldKey];
      } 
      const valueOfficeSeats = Number(_.get(orderData, fieldOfficeSeats, 0)) + 3;
      const valueIsTheirAnyReasonToGoThrough = 
        _.get(orderData, filedIsTheirAnyReasonToGoThroughMySOF, '');
      const fieldsToDeleteIfTrue = [
        fieldDeviceType,
        fieldWillTheLocalPhoneNumberBePortedIn,
        fieldProvider,
        fieldPhoneNumber,
        fieldWillTheTollFreeBePortedIn,
        fieldTollFreePhoneNumber,
      ];
      
      const fieldsToDeleteIfTollFreeAndTrue = [
        fieldRateCenterProvince,
        fieldRateCenter,
      ];  
      if (
        (fieldsToDeleteIfTrue.includes(fieldKey) && (isAllValuesNoOdyssey || isThisOdysseyAIOrder)) ||
        (fieldKey === fieldCustomerTollFreeLocalNumberOdyssey && !isAllValuesNoOdyssey && !isThisOdysseyAIOrder) ||
        (fieldsToDeleteIfTollFreeAndTrue.includes(fieldKey) && valueCustomerTollFree === tollFree && (isAllValuesNoOdyssey || isThisOdysseyAIOrder))
      ) {
        delete result[fieldKey];
      }
      if(fieldKey === fieldPhoneNumbersBeportedOdyssey && !isAllValuesNoOdyssey && !isThisOdysseyAIOrder){
        delete result[fieldKey];
      }
      if (fieldKey === fieldPhoneNumbersBeportedOdyssey && valueOfficeSeats <= valuePNportedIn) {
        result[fieldKey] = `Value must be less than ${valueOfficeSeats}`; 
      }
    
      if (
        fieldKey.startsWith(fieldPhoneNumberOdyssey) &&
        (isAllValuesNoOdyssey || isThisOdysseyAIOrder) &&
        currentForm[fieldPhoneNumberOdyssey]
      ) {
        const numbersOnlyRegex = /^\d+$/; // Regex to ensure only numbers are allowed
      
        currentForm[fieldPhoneNumberOdyssey].forEach((x, index) => {
          if (x.length === 0) {
            result[`phoneNumberOdyssey_${index}`] = fieldRequiredMessage; // Field is empty
          } else if (!numbersOnlyRegex.test(x)) {
            result[`phoneNumberOdyssey_${index}`] = 'Invalid Phone Number'; // Invalid characters
          } else {
            delete result[`phoneNumberOdyssey_${index}`]; // Validation passed
          }
        });
      }      
      
    });
  
    return result;
  };

  const onEdit = index => {
    const newFormData = { ...forms[index] };
    setCurrentForm(newFormData);
    forms.splice(index, 1);
    setCurrentIndex(forms.length);
    setForms([...forms]);
  };

  const nextSeat = () => {
    const errorObject = validateForm();
    setFieldErrors(errorObject);
    if (Object.keys(errorObject).length === 0) {
      if (seatCount > currentIndex + 1) {
        if (currentForm[applyToX]) {
          const applyToXTimes = parseInt(currentForm[applyToX], 10);
          const filledArray = [];
          let newFormsData = forms;
  
          const isBYOD = currentForm[deviceType] === deviceBYOD;
          const deviceKey = isBYOD
            ? deviceBYOD
            : `${currentForm.deviceType}__${currentForm.devicePaymentMethod}`;
          const deviceMaxQty =
            getDeviceInitQuantity(deviceKey) -
            getDeviceQuantity(deviceKey, false);
  
          if (applyToXTimes > deviceMaxQty) {
            setFieldErrors({
              applyToTheNextXSeatsOnThisOrder: stringInterpolation(
                errorTotalMessage,
                deviceMaxQty
              )
            });
          } else if (applyToXTimes + currentIndex + 1 > seatCount) {
            setFieldErrors({
              applyToTheNextXSeatsOnThisOrder: stringInterpolation(
                errorMessage,
                seatCount
              )
            });
          } else {
            if (currentIndex === 0) {
              currentForm[applyToX] = undefined;
              newFormsData = [];
            }
            setCurrentIndex(currentIndex + applyToXTimes);
            for (let i = 0; i < applyToXTimes; i += 1) {
              filledArray.push({ ...currentForm });
            }
            currentForm[deviceType] = undefined;
            setCurrentForm({ ...currentForm });
            setForms([...newFormsData, ...filledArray]);
          }
        } else {
          setCurrentIndex(currentIndex + 1);
          setForms([...forms, { ...currentForm }]);
          setCurrentForm({ ...formObjectKeys, creationDate: new Date() });
        }
      }
    }
  };

  const continueBtn = () => {
    const errorObject = validateForm();
    if (Object.keys(errorObject).length === 0) {
      if (seatCount === currentIndex + 1 || isRecontractFlow) {
        const updateFormsData = [...forms, currentForm].map(item => {
          return { ...item, [applyToX]: 0 };
        });
        submitOrder(updateFormsData);
      }
    } else {
      setFieldErrors(errorObject);
    }
  };

  const saveAndExit = () => {
    const updateFormsData = [...forms, currentForm];
    onSaveAndExit({ [key]: updateFormsData });
  };
  const phoneNumber = (fieldName) => {
    if (fieldName === fieldPhoneNumber) {
      return true;
    }
    if (fieldName === fieldPhoneNumberOdyssey) {
      return true;
    }
    return false;
  };

  const onPhoneNumberChange = (npa, nxx, number, type) => {
    let payload = { ...currentForm, npa, nxx, number };
    if (npa && nxx && number && number.length === 4) {
      payload = { ...payload, phoneNumber: `${npa}${nxx}${number}` };
    } else if (type === 'npa' && npa) {
      payload = { ...payload, phoneNumber: 0, nxx: 0, number: 0 };
    } else {
      payload = { ...payload, phoneNumber: 0 };
    }
    setCurrentForm({ ...payload });
  };
//   const onPhoneNumberChangeOdyssey = (value, nameField) => {
//     let payload = { 
//         ...currentForm,         
//         [nameField]: value  
//     };

//     setCurrentForm({...payload});
// };
const onPhoneNumberChangeOdyssey = (value, fieldName, index) => {
  setCurrentForm(prevForm => {
      const updatedArray = [...(prevForm[fieldName] || [])]; // Get existing array or create a new one
      updatedArray[index] = value; // Set value at the specified index
      return {
          ...prevForm,
          [fieldName]: updatedArray, // Update the field with the modified array
      };
  });
};

  const renderPhoneNumberField = () => {
    return (
      <div style={{ position: 'relative' }}>
        <div>
          <span className="frg-body-font-14px">
            {formFieldMap.phoneNumber.label}
          </span>
        </div>
        <div
          className="frg-select-container color-light"
          style={{ position: 'relative', width: '100px', height: '44px' }}
        >
          <select
            id="NPA"
            onChange={({ target: { value } }) =>
              onPhoneNumberChange(value, 0, 0, 'npa')
            }
            value={currentForm && currentForm.npa}
          >
            <option value="">{npaLabel}</option>
            {getNPAOptions(currentForm.rateCenterProvince).map(
              (value, index) => {
                const optionKey = `NPAOption${index}`;
                return (
                  !['name', 'newDidCount'].includes(value) && (
                    <option key={optionKey} value={value}>
                      {value}
                    </option>
                  )
                );
              }
            )}
          </select>
        </div>
        <span style={{ color: '#aaa', fontWeight: 900 }}>-</span>
        <div
          className="frg-select-container color-light"
          style={{ position: 'relative', width: '100px', height: '44px' }}
        >
          <select
            id="NXX"
            onChange={({ target: { value } }) =>
              onPhoneNumberChange(currentForm.npa, value, 0, 'nxx')
            }
            value={currentForm && currentForm.nxx}
          >
            <option value="">{nxxLabel}</option>
            {getNXXOptions(currentForm.rateCenterProvince).map(
              (value, index) => {
                const optionKey = `NXXOption${index}`;
                return (
                  <option key={optionKey} value={value}>
                    {value}
                  </option>
                );
              }
            )}
          </select>
        </div>
        <span style={{ color: '#aaa', fontWeight: 900 }}>-</span>
        <input
          type="text"
          maxLength={4}
          onChange={({ target: { value } }) => {
            // regex that accepts number or empty string
            const re = /^(\s*|\d+)$/;
            if (re.test(value)) {
              onPhoneNumberChange(currentForm.npa, currentForm.nxx, value);
            }
          }}
          className="frg-input-field color-light"
          style={{ width: '100px', display: 'inline-block' }}
          value={currentForm && currentForm.number}
        />
      </div>
    );
  };
  const phoneNumberOdysseyHandling = (fieldName, fieldData) => {
      if (fieldName === fieldPhoneNumber) {
        return renderPhoneNumberField();
      }
      if (fieldName === fieldPhoneNumberOdyssey && valuePNportedIn) {
        // Create an array to store the rendered components
        const elements = [];
        // Use a for loop to push `renderPhoneNumberField` multiple times based on `valuePNportedIn`
        for (let i = 0; i < valuePNportedIn; i++) {
          const currentFieldName = `phoneNumberOdyssey_${i}`;
          const error = fieldErrors[currentFieldName];
          let dataPhoneNumberOdyssey = {
            name: currentFieldName,
            label: `${odysseyPhoneNumber} ${i + 1}`,
            type: "text",
            required: true,
            value: (currentForm[fieldPhoneNumberOdyssey] && currentForm[fieldPhoneNumberOdyssey][i]) || '',
            onChange: ({
                target: {
                  value
                }
              }) =>
              onPhoneNumberChangeOdyssey(value, fieldPhoneNumberOdyssey, i),
            isSearchable: false,
            readonly: false,
            disabled: false,
          };
                  
      elements.push(
      <Fragment key={`phoneNumberField-${i}`}>
        <FieldInput data={dataPhoneNumberOdyssey} /> 
        {error && <Error text={error} />}
       </Fragment>);
      }
      return elements;
      }

      return false;
      };
  
  useEffect(() => {
    if (
      isc2fMigrationFlow &&
      !currentForm[fieldWillTheLocalPhoneNumberBePortedIn] &&
      !isAllValuesNoOdyssey &&
      !isThisOdysseyAIOrder
    ) {
      setCurrentForm(previousValue => ({
        ...previousValue,
        [fieldWillTheLocalPhoneNumberBePortedIn]: yes
      }));
    }
    // if (
    //   _.get(orderData, fieldDoesTheCustomerRequireWhiteGlove, '') ===
    //     valueNoInstall &&
    //   !currentForm[fieldWillTheLocalPhoneNumberBePortedIn] &&
    //   !currentForm[fieldWillTheTollFreeBePortedIn]
    // ) {
    //   setCurrentForm(previousValue => ({
    //     ...previousValue,
    //     [fieldWillTheLocalPhoneNumberBePortedIn]: no,
    //     [fieldWillTheTollFreeBePortedIn]: no
    //   }));
    // }
  }, [currentForm]);

  const title = isOfficeSeat
    ? `${name} ${currentIndex + 1} of ${seatCount}`
    : name;

  const getButtons = () => (
    <SeatDetailsButtonWrapper>
      <div id="footer-wrapper">
        <BoxWrapper>
          <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
            <Button
              type="button"
              onPress={prevStep}
              variant={{ priority: 'low' }}
            >
              {backButtonLabel}
            </Button>
            {!isOrderFulfillmentTeam && (
              <Button
                type="button"
                onPress={saveAndExit}
                variant={{ priority: 'low' }}
                disabled={!isFormTouched}
              >
                {saveContinueLaterButtonLabel}
              </Button>
            )}
            {isOfficeSeat && seatCount > 1 && currentIndex < +seatCount - 1 && (
              <Button
                type="button"
                variant={{ priority: 'high' }}
                disabled={seatCount <= currentIndex + 1}
                onPress={() => nextSeat()}
              >
                {nextSeatButtonLabel}
              </Button>
            )}
            {((isOfficeSeat && currentIndex === +seatCount - 1) ||
              !isOfficeSeat) && (
              <Button
                type="button"
                variant={{ priority: 'high' }}
                onPress={() => continueBtn()}
              >
                {continueButtonLabel}
              </Button>
            )}
          </div>
        </BoxWrapper>
      </div>
    </SeatDetailsButtonWrapper>
  );

  return (
    <>
      {Object.keys(orderData).length === 0 || !rateCenterData ? (
        <ValidateLoader message={loading} />
      ) : (
        <>
          <GroupWrapper style={{ marginBottom: '1em' }}>
            <GroupTitle>{title}</GroupTitle>
            {formFields.map(({ fields }, index) => {
      const valueIsTheirAnyReasonToGoThroughMySOF =
              _.get(orderData, filedIsTheirAnyReasonToGoThroughMySOF, '') === yes;
              const valueIsTheirAnyReasonToGoThrough =
              _.get(orderData, filedIsTheirAnyReasonToGoThroughMySOF, '');
              const valueCustomerTollFree = get( currentForm, fieldCustomerTollFreeLocalNumberOdyssey);
              if (
                isOfficeSeat &&
                currentIndex === +seatCount - 1 &&
                fields.name === 'applyToTheNextXSeatsOnThisOrder'
              )
                return null;
              const fieldKey = `SeatDetails${name}${index}${currentIndex}`;
              const fieldName = fields.name;
              let isDisabled = false;

              if (
                isc2fMigrationFlow &&
                fieldName === fieldWillTheLocalPhoneNumberBePortedIn &&
                currentForm[fieldWillTheLocalPhoneNumberBePortedIn] === yes
              ) {
                currentForm.provider = 'TELUS';
                currentForm[fieldWillTheTollFreeBePortedIn] = 'No';
              }
              if (
                isc2fMigrationFlow &&
                [fieldProvider, fieldWillTheTollFreeBePortedIn].includes(
                  fieldName
                )
              )
                isDisabled = true;
                const fieldsToDisable = [
                  fieldDeviceType,
                  fieldCustomerTollFreeLocalNumberOdyssey,
                  fieldRateCenterProvince,
                  fieldRateCenter,
                  fieldWillTheLocalPhoneNumberBePortedIn,
                  fieldProvider,
                  fieldPhoneNumber,
                  fieldWillTheTollFreeBePortedIn,
                  fieldTollFreePhoneNumber,
                ];

                if (
                  fieldName === fieldPhoneNumbersBeportedOdyssey &&
                  !isAllValuesNoOdyssey && !isThisOdysseyAIOrder
                ) {
                  fields.required = false;
                  return false;
                }

              // this field is only visible for LocalNumber
              const isRateCenterField =
                fieldName === fieldRateCenter ||
                fieldName === fieldRateCenterProvince;

              // 1. Field must be in the disable list
              const isFieldEligible = fieldsToDisable.includes(fieldName);

              // 2. Logic for the customerTollFreeLocalNumberOdyssey field
              const shouldDisableBasedOnOdyssey =
                fieldName === fieldCustomerTollFreeLocalNumberOdyssey
                  ? (!isAllValuesNoOdyssey && !isThisOdysseyAIOrder) // opposite condition
                  : (isAllValuesNoOdyssey || isThisOdysseyAIOrder);        // regular condition

              // 3. Rate center fields require an extra toll-free check
              const passesRateCenterCheck =
                !isRateCenterField || valueCustomerTollFree === tollFree;

              // FINAL CONDITION
              if (
                isFieldEligible &&
                shouldDisableBasedOnOdyssey &&
                passesRateCenterCheck
              ) {
                fields.required = false;
                return false;
              }
              // if (
              //   _.get(orderData, fieldDoesTheCustomerRequireWhiteGlove, '') ===
              //     valueNoInstall &&
              //   [
              //     fieldWillTheLocalPhoneNumberBePortedIn,
              //     fieldWillTheTollFreeBePortedIn
              //   ].includes(fieldName)
              // )
              //   isDisabled = true;

              const getOptions = options => {
                let result;
                switch (fieldName) {
                  case 'rateCenter':
                    result = getRateCenterOptions(
                      currentForm.rateCenterProvince
                    );
                    break;
                  case deviceType:
                    result = [...devices()];
                    break;
                  default:
                    result = options;
                }
                return result;
              };

              const fieldData = {
                ...formFieldMap[fieldName],
                readonly: isDisabled,
                disabled: isDisabled,
                options: fieldName === deviceType ? devices() : getOptions(formFieldMap[fieldName].options),
                value:
                  fieldName === deviceType &&
                  currentForm.deviceType &&
                  currentForm.devicePaymentMethod
                    ? `${currentForm.deviceType.trim()}__${currentForm.devicePaymentMethod.trim()}`
                    : currentForm[fieldName],
                onChange: ({ target: { value } }) => {
                  if (fieldName === deviceType && value.includes('__')) {
                    const [name, payForDevice] = value.split('__').map(x => x.trim());
                    const updatedForm = {
                      ...currentForm,
                      deviceType: name,
                      devicePaymentMethod: payForDevice,
                    };
                    setCurrentForm(updatedForm);
                    if (!isFormTouched) setIsFormTouched(true);
                  } else {
                    handleFormField(fieldName, value);
                  }
                }
              };

              const error = fieldErrors[fieldName];
              if (!isRelatedFieldExisted(fields)) return null;
              return (
                <Fragment key={fieldKey}>
                  {phoneNumber(fieldName) ? (
                   phoneNumberOdysseyHandling(fieldName , fieldData)
                    
                  ) : (
                    <FormField data={fieldData} />
                  )}
                  {error && <Error text={error} />}
                </Fragment>
              );
            })}
          </GroupWrapper>
          <Divider space={2} variant={{ inverse: true }} />
          {forms.length > 0 && isOfficeSeat && valueCustomerTollFree !== tollFree && (
            <SeatDetailsTable
              forms={forms}
              onDelete={onDelete}
              onEdit={onEdit}
              isAllValuesNoOdyssey={isAllValuesNoOdyssey || isThisOdysseyAIOrder}
            />
          )}
        </>
      )}
      {getButtons()}
    </>
  );
};

SeatDetailsForm.propTypes = {
  data: PropTypes.shape({
    key: PropTypes.string.isRequired,
    formFields: PropTypes.arrayOf(PropTypes.shape({})),
    name: PropTypes.string.isRequired
  }).isRequired,
  orderData: PropTypes.shape({
    id: PropTypes.string,
    officeSeats: PropTypes.string,
    starterSeat: PropTypes.string,
    devices: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  updateStep: PropTypes.func.isRequired,
  step: PropTypes.number.isRequired,
  setOrderData: PropTypes.func.isRequired,
  onSaveAndExit: PropTypes.func.isRequired,
  isOrderFulfillmentTeam: PropTypes.bool.isRequired,
  prevStep: PropTypes.func.isRequired
};

export default SeatDetailsForm;
